module.exports = __webpack_public_path__ + "img/image_catalog_thumbnail_error.f1d8a3aa.png";